import { createStore } from "vuex";

const store = createStore({
    state: {
        account: "",
    },  //相当于组件中的data，定义数据的地方
    mutations: {
        setAccount(state, account) {
            state.account = account;
        },
    },  //更改数据的唯一方法，需要使用commit函数
    actions: {},  //配置异步操作，需要使用dispatch函数
    getters: {},  //计算属性
    modules: {}  //模块化
})

export default store
